import client from "@/api/client"
import { createAuthenticatedQuery } from "../createAuthenticatedQuery"

export const useGetBackupStatusQuery = createAuthenticatedQuery({
  primaryKey: "backup-status",
  queryFn: () => client.api.backupControllerGetUserBackup().then(res => res.data),
})
